import { useCallback, useEffect, useState } from "react";
import { ApiError } from "../../lib/api-client";
import { useAuth } from "../auth/useAuth";

export function useAdminResource<T>(fetcher: () => Promise<T>, deps: unknown[]) {
  const { logout } = useAuth();
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(() => {
    setLoading(true);
    setError(null);
    return fetcher()
      .then((result) => {
        setData(result);
        setLoading(false);
      })
      .catch((requestError: unknown) => {
        if (requestError instanceof ApiError && requestError.status === 401) {
          logout();
          return;
        }
        setError(
          requestError instanceof Error ? requestError.message : "Failed to load data",
        );
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  useEffect(() => {
    void load();
  }, [load]);

  return { data, loading, error, refresh: load };
}
